import { useScriptInjector } from '../useScriptInjector';
import {useEffect} from 'react';
import useProfileStore from '../../core/UserProfileStore';
import {REACT_APP_AHA_APPLICATION_ID} from '../../../constants';
import { useGlobalStore } from '../../core/GlobalStore';

const Aha = () => {

  const isScriptDefer = false;
  const isAsync = true;
  const {oktaUserProfile} = useProfileStore();;
  const { setAhaLoaded, isAhaLoaded} = useGlobalStore();
  
  const ahaScript = useScriptInjector(
    `/thirdParty/ahaideas.js`,
    isAsync,
    isScriptDefer, "ahascript" ,undefined, 
    setAhaLoaded
  );
  
  useEffect(()=>{
    if(window.aha && oktaUserProfile?.profile?.email){
      const aha = window.aha;
      oktaUserProfile && aha('initialize', {
            account: 'cdk',
            applicationId: REACT_APP_AHA_APPLICATION_ID,
            user: {
              id: oktaUserProfile?.profile?.email,
              name: `${oktaUserProfile?.profile?.firstName} ${oktaUserProfile?.profile?.lastName}`,
              email: oktaUserProfile?.profile?.email,
            },
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[ ahaScript,window.aha, oktaUserProfile,isAhaLoaded]);


  return  null;

}

export default Aha; 